import React from 'react';
import './ReviewCard.css';

const ReviewCard = ({ name, feedback, rating, image }) => {
  return (
    <div className="review-card p-4 h-100 shadow-sm">
      <div className="d-flex align-items-center mb-3">
        <div className="reviewer-img-wrapper position-relative">
          
          {/* ICON LOGIC: If image exists, show it. Otherwise, show the common Person Icon */}
          {image ? (
            <img 
              src={image} 
              alt={name} 
              className="rounded-circle" 
              style={{ width: '50px', height: '50px', objectFit: 'cover' }} 
            />
          ) : (
            <div className="common-avatar-icon rounded-circle d-flex align-items-center justify-content-center">
              <i className="bi bi-person-fill"></i>
            </div>
          )}
          
          <div className="quote-icon shadow-sm">
            <i className="bi bi-quote"></i>
          </div>
        </div>

        <div className="ms-3">
          <h6 className="mb-0 fw-bold" style={{ color: '#1e293b' }}>{name}</h6>
          <div className="stars text-warning" style={{ fontSize: '12px' }}>
            {[...Array(5)].map((_, i) => (
              <i key={i} className={`bi ${i < rating ? 'bi-star-fill' : 'bi-star'}`}></i>
            ))}
          </div>
        </div>
      </div>
      
      <p className="text-muted small mb-0 lh-base">
        "{feedback}"
      </p>
    </div>
  );
};

export default ReviewCard;